module.exports = __webpack_public_path__ + "static/scholarjet-demo-7420ffb10de7d3834ff21e3b5b5d35ac.mp4";